import CancelIcon from "@mui/icons-material/Cancel"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { Stack, Typography } from "@mui/material"
import { ReactElement } from "react"

import { formatKeys } from "../singleApplicationKeys"
import type { TEscalatedOutcomesListProps } from "./amendmentHistoryTypes"

/**
 * Displays a list of ENA assessment escalated outcomes for a single
 * amendment entry.  Failed outcomes show a red cancel icon; passed
 * outcomes show a green check icon.
 */
const EscalatedOutcomesList = ({
    outcomes,
}: TEscalatedOutcomesListProps): ReactElement => {
    const formatted = formatKeys(outcomes)

    if (Object.keys(formatted).length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                No escalated outcomes available.
            </Typography>
        )
    }

    return (
        <>
            {Object.entries(formatted).map(([key, value]) => (
                <Stack
                    key={key}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography>{key}</Typography>
                    {value === false ? (
                        <CancelIcon color="error" />
                    ) : (
                        <CheckCircleIcon color="success" />
                    )}
                </Stack>
            ))}
        </>
    )
}

export default EscalatedOutcomesList
